import React from "react";

const TONE = {
  default: "bg-white text-zinc-900 hover:bg-zinc-900 hover:text-white",
  warn: "bg-white text-orange-700 hover:bg-orange-600 hover:text-white",
  ok: "bg-white text-emerald-700 hover:bg-emerald-600 hover:text-white",
  danger: "bg-white text-red-600 hover:bg-red-600 hover:text-white",
  muted: "bg-zinc-100 text-zinc-300 border-zinc-300 cursor-not-allowed",
};

export default function IconBtn({ icon: Icon, title, onClick, testId, tone = "default" }) {
  return (
    <button
      type="button" title={title} aria-label={title} onClick={onClick} data-testid={testId} disabled={tone === "muted"}
      className={`inline-flex items-center justify-center w-7 h-7 border border-zinc-900 transition-colors ${TONE[tone] || TONE.default}`}
    >
      <Icon size={13} />
    </button>
  );
}
